import { VerificationRequest, ConfirmationRequest} from '../../models';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';

@Injectable({ providedIn: 'root' })
export class ConfirmationRequestService extends ApiService {
  endPoint = '/api/confirmationrequest';
  verificationRequest(data: VerificationRequest) {
    return this.http.post(`${this.identityBaseUrl}${this.endPoint}/verificationrequest`, data);
  }

  confirmationRequest(data: ConfirmationRequest) {
    return this.http.post(`${this.identityBaseUrl}${this.endPoint}/confirmationrequest`, data);
  }

}
